exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".i-frame {\n  margin-bottom: 15px;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n  min-height: 652px;\n}\n.i-frame-iframe {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.new-shopping-iframe {\n  width: 100%;\n  height: 100%;\n}\n.new-newShopIndex-iframe {\n  width: 100%;\n}\n", ""]);

// exports
